import React from "react";
import NewAccordion from "../../../utilities/NewAccordion";
import xss from "xss";

const FAQ = ({ slice }) => {
  const darkTheme = slice?.primary?.theme === "dark";
  const generateFAQStructuredData = () => {
    if (!slice?.items?.length) return null;

    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      name: "Frequently Asked Questions",
      mainEntity: slice.items
        .map((item) => {
          const questionName = item?.heading?.text?.trim();

          return {
            "@type": "Question",
            name: questionName || "Unnamed Question",
            acceptedAnswer: {
              "@type": "Answer",
              text:
                item?.description?.text ||
                item?.description?.html?.replace(/<[^>]*>/g, "") ||
                "",
            },
          };
        })
        .filter((item) => item.name && item.acceptedAnswer.text),
    };

    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: xss(JSON.stringify(faqData)) }}
      />
    );
  };

  return (
    <>
      {generateFAQStructuredData()}
      <div className={`${darkTheme && "bg-purple-1100"}`}>
        <div className="flex max-w-6xl py-8 xl:px-0 lg:px-6 sm:px-10 px-4 justify-center mx-auto">
          <div
            className={`flex flex-col gap-8 lg:flex-row lg:gap-9 ${darkTheme && "faqDarkTheme "}`}
          >
            <div
              className={`min-w-[275px] ${darkTheme ? "text-white" : "text-purple-1100"} sm:leading-10 tracking-[-1.8px] text-2.5xl sm:text-3.25xl text-center lg:text-left font-bold sm:font-semibold`}
            >
              {slice?.primary?.title?.text}
            </div>

            <ul className="list_gap font-inter text-lg font-normal leading-7 tracking-tighter_3">
              {slice?.items?.map((item, index) => (
                <NewAccordion
                  key={`answer_${index}`}
                  title={item?.heading?.text}
                >
                  {item?.description?.html ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: xss(item?.description?.html),
                      }}
                    />
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: xss(item?.description?.text),
                      }}
                    />
                  )}
                </NewAccordion>
              ))}
              <span
                className="block border-t border-gray-200"
                aria-hidden="true"
              />
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
